<div class="author-card">
  <img
    class="author-card__avatar"
    [src]="post().authorAvatarUrl"
    [alt]="post().authorName"
    width="64"
    height="64"
    loading="lazy"
  />

  <div class="author-card__info">
    <h3 class="author-card__name">{{ post().authorName }}</h3>
    <span class="author-card__role">{{ post().authorRole }}</span>
    @if (post().authorBio) {
      <p class="author-card__bio">{{ post().authorBio }}</p>
    }
    @if (post().authorArticleCount) {
      <span class="author-card__count">{{ copy.authorArticleCount(post().authorArticleCount!) }}</span>
    }
  </div>
</div>
